const isKeyOf = (key, mapperArgs) => mapperArgs.hasOwnProperty(key);
const identity = (v) => v;
const isExperimentOpen = (experimentName, experiments) => ['new', true].includes(experiments[experimentName]);
export const migrateFields = (configs) => (rawMapperArgs) => configs.reduce((mapperArgs, { targetNamespace, sourceNamespace = targetNamespace, fields, enhancer = identity, experiment, }) => {
    if (!isKeyOf(sourceNamespace, mapperArgs)) {
        throw new Error(`migrateFields: ${sourceNamespace} was not found`);
    }
    if (!isKeyOf(targetNamespace, mapperArgs)) {
        throw new Error(`migrateFields: ${targetNamespace} was not found`);
    }
    if (experiment && !isKeyOf('experiments', mapperArgs)) {
        throw new Error(`migrateFields: experiments was not found`);
    }
    const sourceObj = mapperArgs[sourceNamespace];
    const targetObj = mapperArgs[targetNamespace];
    const namespacesConfigs = fields.map(field => typeof field === 'string' ? { source: field, target: field } : field);
    const newTargetObj = namespacesConfigs.reduce((acc, field) => {
        const shouldTryToUseTargetValue = experiment
            ? isExperimentOpen(experiment, mapperArgs.experiments)
            : true;
        const targetValueExist = targetObj[field.target] !== undefined;
        return shouldTryToUseTargetValue && targetValueExist
            ? acc
            : {
                ...acc,
                [field.target]: enhancer(sourceObj[field.source], mapperArgs),
            };
    }, targetObj);
    return {
        ...mapperArgs,
        [targetNamespace]: newTargetObj,
    };
}, rawMapperArgs);
//# sourceMappingURL=migrateFields.js.map